module.exports = __webpack_public_path__ + "static/media/googlelogin.8bce00b9.png";